











import traceQuery from '~/queries/trace.gql'

export default

	data: ->
		loaded: false
		sectionData: {}

	props:
		smallNav:
			type: Boolean
			default: false

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'sustainability'
				slug: 'sustainability'

		@loaded = true

	computed:
		block: -> {
			id: @sectionData.id
			componentName: 'blocks-tout-carousel'
			showLines: false
			cards: @sectionData.carousel
		}

		classes: -> [
			'small-nav' if @smallNav
		]


